import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useUser = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [userList, setUserList] = useState<UserListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.user.list, location.search],
    () =>
      fetcher.user.postUserList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',        
        use: searchParams.use ? String(searchParams.use) : '',
        position: searchParams.position ? String(searchParams.position) : '',        
      }),
    {
      onSuccess: (res: UserListResDto) => {
        switch (res.code) {
          case 200:
            setUserList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: userInsert } = useMutation(
    [endpoints.user.add],
    fetcher.user.postUserAdd,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: userUpdate } = useMutation(
    [endpoints.user.update],
    fetcher.user.postUserUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: resetPassword } = useMutation(
    [endpoints.user.resetpassword],
    fetcher.user.postResetPassword,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_RESET_PASSWORD, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { isLoading, userList, searchResult, refetch, userInsert, userUpdate, resetPassword  };
};

export default useUser;
